export enum FONT_SIZES {
    DEFAULT = "0",
    MEDIUM = "1",
    LARGE = "2"
};
